var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-things-to-do" }, [
    _c("div", { staticClass: "home-section-header" }, [
      _c("h3", { domProps: { innerHTML: _vm._s(_vm.headline) } })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "things-to-do-items" },
      _vm._l(_vm.thingsToDo, function(item, idx) {
        return _c(
          "a",
          {
            key: "tdih-" + idx,
            staticClass: "things-to-do-item",
            attrs: { href: item.link.url, target: item.link.target }
          },
          [
            _c("div", { staticClass: "things-to-do-thumb" }, [
              _c("img", {
                attrs: { src: item.image.sizes.medium_large, title: item.title }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "things-to-do-content" }, [
              _c("h3", {
                domProps: { innerHTML: _vm._s(_vm.labels[item.site_category]) }
              }),
              _vm._v(" "),
              _c("h4", { domProps: { innerHTML: _vm._s(item.title) } })
            ])
          ]
        )
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-loader/lib?{}!/Users/nick/Desktop/Projects/kinston/wp-content/themes/kinston/node_modules/vue-svg-inline-loader/dist/index.min.js?{}!./scripts/components/ThingsToDoFeatured.vue?vue&type=template&id=04a8f392&
// module id = 423
// module chunks = 0